import { createContext, useContext } from 'react';
import { tChatSearchContext } from './ChatSearch.types';

/**
 * Null outside a ChatSearchProvider — and with useMessageSearchEnabled off,
 * where the provider renders its children bare. Every consumer treats null as
 * "the in-chat search does not exist", so the flag off leaves the chat exactly
 * as it was.
 */
export const ChatSearchContext = createContext<tChatSearchContext | null>(null);

export const useChatSearchContext = (): tChatSearchContext | null =>
  useContext(ChatSearchContext);
